import React, { useState, useEffect } from "react";
import TableStyle from "components/Content/Table/TableStyle.module.css";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Slide,
    InputLabel,
    Select,
    FormLabel,
    Paper,
    TextField,
    FormControlLabel,
    Checkbox,
    FormControl,
    Alert,
    MenuItem,
    Snackbar,
    Switch,
    Divider
} from "@mui/material";
import ButtonStyle from "components/Button/ButtonStyle.module.css";
import { Box } from "@mui/material";
import { apiGet, apiPost } from "app/Services/ApiService";
import { apiUrls } from "common/ApiUrls";
import _ from 'lodash';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
export default function BenefitSettingsModal(props) {
    const validationSchema = Yup.object().shape({
        benefitName: Yup.string().required('Benefit name is required'),
        variableTypeID: Yup.string().required('Calculation type is required'),
        benefitTypeID: Yup.string().required('Benefit type is required'),
        carrierID: Yup.string().required('Carrier is required'),
    });
    const {
        register,
        control,
        handleSubmit,
        reset,
        setValue,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(validationSchema)
    });
    const EMPTY_GUID = '00000000-0000-0000-0000-000000000000'
    const [savingData, setSavingData] = React.useState(false)
    const [checkingData, setCheckingData] = useState(true)
    const [openModal, setOpen] = useState(false)
    const [openRates, setOpenRates] = useState(false)
    const [coverageRates, setCoverageRates] = useState([])

    const [benefitCalcTypes, setBenefitCalcTypes] = useState([])
    const [variableTypeID, setVariableTypeID] = useState('')
    const [benefitTypeID, setBenefitTypeID] = useState('')
    const [carrierID, setCarrierID] = useState('')
    const [benefitName, setBenefitName] = useState('')

    const [isFringeCost, setIsFringeCost] = useState(false)
    const [coverageList, setCoverageList] = useState([])
    const [benefitTypeList, setBenefitTypeList] = useState([])
    const [carrierList, setCarrierList] = useState([])
    const [currentBenefit, setCurrentBenefit] = useState({})
    const [openSnack, setOpenSnack] = useState(false)
    const [canEdit, setCanEdit] = useState(props.canEdit??false)
    useEffect(() => {
        if (props.canEdit) {
            setCanEdit(props.canEdit)
        }
        if (coverageList.length == 0) {
            fetchCoverageLevels()
        }
        if (benefitTypeList.length == 0) {
            fetchBenefitTypes()
        }
        if (carrierList.length == 0) {
            fetchCarriers()
        }

        apiGet(apiUrls.getVariableTypes('BENEFITCONFIG-CALC'))
            .then((response) => {
                // console.dir('variable types')
                // console.dir(response)
                setBenefitCalcTypes(response.data)
            })
            .catch(function (error) {
                console.error(error)
                // console.log("THIS IS ERROR", error);          
                setBenefitCalcTypes([])
            })
            .then(function () {

            });

    }, [])

    useEffect(() => {
        // console.dir('reset')
        // console.dir(props.benefit)
        reset({
            "variableTypeID": 1,
            "minCoverage": 0,
            "maxCoverage": 0
        })
        fetchBenefitDetails(props.benefit)

    }, [props.benefit])

    useEffect(() => {
        // console.log('open')
        if (props.callbackCloseModal) {
            props.callbackCloseModal()
        }
    }, [openModal])

    useEffect(() => {
        if (props.canEdit) {
            setCanEdit(props.canEdit)
        }
    }, [props.canEdit])

    const onSubmit = data => {
        // console.dir('submit')
        // console.dir(data)
        handleSave(data)

    };
    const fetchCoverageLevels = () => {
        apiGet(apiUrls.getCoverageLevels())
            .then((response) => {
                const cl = response.data.map((c) => {
                    return {
                        costShareID: c.costShareID,
                        coverageLevelId: c.coverageLevelId,
                        coverageLevelName: c.coverageLevelName,
                        coverageLevelCode: c.coverageLevelCode,
                        enabled: false,
                        EmployeePercentage: 0,
                        EmployerAmount: 0,
                        autoEnroll: false
                    }
                })
                setCoverageList(cl)
            })
            .catch(function (error) {
                // console.error(error)
                setCoverageList([])
            })
            .then(function () {

            });
    }

    const fetchBenefitTypes = () => {
        apiGet(apiUrls.getBenefitType())
            .then((response) => {
                // console.log('benefit type list')
                // console.log(response)
                const bt = response.data.map((c) => {
                    return {
                        benefitTypeID: c.benefitTypeID,
                        benefitTypeName: c.benefitTypeName,
                        benefitTypeCode: c.benefitTypeCode
                    }
                })
                setBenefitTypeList(bt)
            })
            .catch(function (error) {
                // console.error(error)
                setBenefitTypeList([])
            })
            .then(function () {

            });
    }

    const fetchCarriers = () => {
        apiGet(apiUrls.getCarrier())
            .then((response) => {
                // console.log('carrier list')
                // console.log(response)
                const cc = response.data.map((c) => {
                    return {
                        carrierID: c.carrierID,
                        carrierName: c.carrierName,
                        carrierCode: c.carrierCode
                    }
                })
                setCarrierList(cc)
            })
            .catch(function (error) {
                // console.error(error)
                setCarrierList([])
            })
            .then(function () {

            });
    }
    const fetchBenefitDetails = (benefit) => {
        setCurrentBenefit({})
        const selectedCompany = localStorage.getItem(`selectedCompanyId`);
        if (benefit.benefitID == EMPTY_GUID) {
            // console.log('new benefit')
            setCurrentBenefit(benefit)
            setVariableTypeID(EMPTY_GUID)
            setBenefitName('')
            setCarrierID(EMPTY_GUID)
            setBenefitTypeID(EMPTY_GUID)
            setIsFringeCost(true)

            let cList = [...coverageList]
            for (let cl of cList) {
                cl.enabled = false
                cl.EmployeePercentage = 0
                cl.EmployerAmount = 0
                cl.autoEnroll = false
            }
            setCoverageList(cList)
            return
        }
        if (benefit.planPeriodID && benefit.benefitID) {
            setCheckingData(true);
            apiGet(apiUrls.getPlanBenefitDetail(selectedCompany, benefit.planPeriodID, benefit.benefitID))
                .then((response) => {
                    // console.log(response)
                    setCurrentBenefit(response.data)
                    let benfitConfig = response.data.benefitConfiguration
                    setVariableTypeID(benfitConfig.variableTypeID)
                    setBenefitName(response.data.benefitName)
                    setCarrierID(response.data.carrierID)
                    setBenefitTypeID(response.data.benefitTypeID)
                    // setMinCoverage(benfitConfig.minimumCoverageAmount)
                    // setMaxCoverage(benfitConfig.maximumCoverageAmount)
                    // setIsHwContribution(benfitConfig.isHWContribution)
                    setIsFringeCost(benfitConfig.isFringeCost)

                    let costshares = []
                    for (let cs of response.data.costShares) {
                        costshares.push({
                            costShareID: cs.costShareID,
                            coverageLevelId: cs.coverageLevelId,
                            coverageLevelCode: cs.coverageLevelCode,
                            benefitCoverageID: cs.benefitCoverageID,
                            benefitID: cs.benefitID,
                            planPeriodID: cs.planPeriodID,
                            enabled: true,
                            EmployeePercentage: cs.employeePercentage,
                            EmployerAmount: cs.employerAmount,
                            autoEnroll: cs.autoEnroll
                        })
                    }

                    let cList = [...coverageList]
                    for (let cl of cList) {
                        cl.enabled = false
                        cl.EmployeePercentage = 0
                        cl.EmployerAmount = 0
                        cl.autoEnroll = false
                        for (let sl of costshares) {
                            if (cl.coverageLevelCode == sl.coverageLevelCode) {
                                // console.log(cl.coverageLevelCode)
                                cl.costShareID = sl.costShareID
                                cl.benefitCoverageID = sl.benefitCoverageID
                                cl.benefitID = sl.benefitID
                                cl.planPeriodID = sl.planPeriodID
                                cl.enabled = true
                                cl.EmployeePercentage = sl.EmployeePercentage
                                cl.EmployerAmount = sl.EmployerAmount
                                cl.autoEnroll = sl.autoEnroll
                                break
                            }
                        }
                    }
                    // console.log('clist')
                    // console.dir(cList)
                    setCoverageList(cList)
                })
                .catch(function (error) {
                })
                .then(function () {
                    // always executed
                    setCheckingData(false);
                });
        }
    };


    const handleClose = () => {
        // console.log('handle close')
        setOpen(false)
        if (props.callbackCloseModal) {
            props.callbackCloseModal()
        }
    };


    const handleSave = (data) => {
        setSavingData(true)
        const selectedCompany = localStorage.getItem(`selectedCompanyId`);
        // console.dir(data)
        // console.dir(coverageList)

        apiPost(apiUrls.postPlanBenefitDetail(selectedCompany, currentBenefit.planPeriodID, currentBenefit.benefitID),
            {
                BenefitID: currentBenefit.benefitID,
                BenefitName: benefitName,
                BenefitTypeID: benefitTypeID,
                CarrierID: carrierID,
                BenefitConfiguration: {
                    VariableTypeId: parseInt(data.variableTypeID),
                    IsFringeCost: data.isFringeCost
                },
                CostShares: coverageList.map(c => {
                    return {
                        CostShareID: c.costShareID,
                        AutoEnroll: c.autoEnroll,
                        CoverageLevelCode: c.coverageLevelCode,
                        CoverageLevelId: c.coverageLevelId,
                        CoverageLevelName: c.coverageLevelName,
                        EmployeePercentage: c.EmployeePercentage,
                        EmployerAmount: c.EmployerAmount,
                        Enable: c.enabled,
                    }
                })
            }
        )
            .then((response) => {
                // console.log('post response')
                // console.dir(response)
                setOpenSnack(true)
            })
            .catch(function (error) {
                // console.log('post response error')
                // console.dir(error)
            })
            .then(function () {
                setSavingData(false)
            });
    };

    const handleChangeCoverage = (c) => {
        // console.dir(c)
        let newList = [...coverageList]
        for (let l of newList) {
            if (l.coverageLevelCode == c.coverageLevelCode) {
                l.enabled = !c.enabled
            }
        }

        setCoverageList(newList)
    }

    const updateCoverageLevel = (c, propName, propValue) => {
        let list = [...coverageList]
        for (let l of list) {
            if (l.coverageLevelCode == c.coverageLevelCode) {
                l[propName] = propValue
            }
        }
        setCoverageList(list)
    }

    const handleViewRates = (costshare) => {
        console.log(costshare, 'costshare')
        const selectedCompany = localStorage.getItem(`selectedCompanyId`);
        setCoverageRates([])
        //getPlanBenefitCoverageRates
        apiGet(apiUrls.getPlanBenefitCoverageRates(selectedCompany, costshare.planPeriodID, costshare.benefitID, costshare.benefitCoverageID))
            .then((response) => {
                setCheckingData(true)
                console.log(response, 'getPlanBenefitCoverageRates')
                setCoverageRates(response.data)
                setOpenRates(true)
            })
            .catch(function (error) {
            })
            .then(function () {
                // always executed
                setCheckingData(false)
            });

    }

    const handleRatesClose = () => {
        setOpenRates(false)
    }

    const renderCoverageRate = (rateType, rates) => {
        if (rateType == 'AGEBASE') {
            return (<table className="table">
                <thead><tr><th>Start</th><th>End</th><th>Tobacco User</th><th>Reduction %</th><th>Amount</th></tr></thead>
                <tbody>
                    {rates.map((r, index) => (
                        <tr><td>{r.ageStart}</td><td>{r.ageEnd}</td><td>{r.tobaccoStatusName}</td><td>{r.ageReduction}</td><td>{r.amount}</td></tr>
                    ))
                    }
                </tbody>
            </table>)
        }
        else if (rateType == 'SALARYBASE') {
            return (<table className="table">
                <thead><tr><th>Start</th><th>End</th><th>Tobacco User</th><th>Amount</th></tr></thead>
                <tbody>
                    {rates.map((r, index) => (
                        <tr><td>{r.salaryStart}</td><td>{r.salaryEnd}</td><td>{r.tobaccoStatusName}</td><td>{r.amount}</td></tr>
                    ))
                    }
                </tbody>
            </table>)
        }
        else if (rateType == 'AGESALARYBASE') {
            return (<table className="table">
                <thead><tr><th>Age Start</th><th>Age End</th><th>Salary Start</th><th>Salary End</th><th>Tobacco User</th><th>Reduction %</th><th>Amount</th></tr></thead>
                <tbody>
                    {rates.map((r, index) => (
                        <tr><td>{r.ageStart}</td><td>{r.ageEnd}</td><td>{r.salaryStart}</td><td>{r.salaryEnd}</td><td>{r.tobaccoStatusName}</td><td>{r.ageReduction}</td><td>{r.amount}</td></tr>
                    ))
                    }
                </tbody>
            </table>)
        }
        else if (rateType == 'HOURS') {
            return (<table className="table">
                <thead><tr><th>Start</th><th>End</th><th>Amount</th></tr></thead>
                <tbody>
                    {rates.map((r, index) => (
                        <tr><td>{r.hoursStart}</td><td>{r.hoursEnd}</td><td>{r.amount}</td></tr>
                    ))
                    }
                </tbody>
            </table>)
        }
        else if (rateType == 'CONTRACTCODE') {
            return (<table className="table">
                <thead><tr><th>Contract Code</th><th>Amount</th></tr></thead>
                <tbody>
                    {rates.map((r, index) => (
                        <tr><td>{r.contractCodeCode}</td><td>{r.amount}</td></tr>
                    ))
                    }
                </tbody>
            </table>)
        }
        else if (rateType == 'CONTRACTCODEPAYDATE') {
            return (<table className="table">
                <thead><tr><th>Contract Code</th><th>Pay Date Start</th><th>Pay Date End</th><th>Amount</th></tr></thead>
                <tbody>
                    {rates.map((r, index) => (
                        <tr><td>{r.contractCodeCode}</td><td>{r.payDateStart}</td><td>{r.payDateEnd}</td><td>{r.amount}</td></tr>
                    ))
                    }
                </tbody>
            </table>)
        }
        else if (rateType == 'AGEHOURS') {
            return (<table className="table">
                <thead><tr><th>Start</th><th>End</th><th>Tobacco User</th><th>Reduction %</th><th>Amount</th><th>Amount Per Hour</th></tr></thead>
                <tbody>
                    {rates.map((r, index) => (
                        <tr><td>{r.ageStart}</td><td>{r.ageEnd}</td><td>{r.tobaccoStatusName}</td><td>{r.ageReduction}</td><td>{r.amount}</td><td>{r.amountPerHour}</td></tr>
                    ))
                    }
                </tbody>
            </table>)
        }
        return <></>;
    }
    const renderCoverage = (c, index) => {
        if (c.enabled) {
            return (<Box
                key={index}
                disablePadding
            >
                <Box >
                    <FormControlLabel control={<Switch
                        tabIndex={-1}
                        checked={c.enabled || false}
                        onClick={() => handleChangeCoverage(c)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />} label={`${c.coverageLevelName}`}
                        sx={{ m: 1, minWidth: 220 }} />

                    <FormControlLabel control={<Checkbox checked={c.autoEnroll || false} />} label="Auto Enroll"
                        disabled={!c.enabled}
                        size="small"
                        onChange={(e) => {
                            updateCoverageLevel(c, 'autoEnroll', e.target.checked)
                        }}
                        sx={{ m: 1, minWidth: 80 }}
                    />

                    <Button variant="outlined" onClick={() => handleViewRates(c)}
                        sx={{ m: 1, minWidth: 80 }}>
                        Rates
                    </Button>
                </Box>
                <Box>
                    <FormControl sx={{ m: 1, minWidth: 200 }} size="small"
                    >
                        <InputLabel htmlFor="filled-EmployerAmount-percent"
                            shrink>Employee %</InputLabel>
                        <TextField
                            size="small"
                            value={c.EmployerAmount || 0}
                            shrink
                            variant="standard"
                            onChange={(e) => {
                                updateCoverageLevel(c, 'EmployerAmount', e.target.value)
                            }}
                            disabled={c.EmployeePercentage > 0}
                        />
                    </FormControl>
                    <FormControl sx={{ m: 1, minWidth: 200 }} >
                        <InputLabel htmlFor="filled-EmployeePercentage-amount"
                            shrink>Employer $</InputLabel>
                        <TextField
                            size="small"
                            value={c.EmployeePercentage || 0}
                            shrink
                            variant="standard"
                            onChange={(e) => {
                                updateCoverageLevel(c, 'EmployeePercentage', e.target.value)
                            }}
                            disabled={c.EmployerAmount > 0}
                        />
                    </FormControl>
                </Box>
                <Divider />
            </Box>)
        }
        else {
            return (<Box
                key={index}
                disablePadding
            >
                <Box >
                    <FormControlLabel control={<Switch
                        tabIndex={-1}
                        checked={c.enabled || false}
                        onClick={() => handleChangeCoverage(c)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />} label={`${c.coverageLevelName}`}
                        sx={{ m: 1, minWidth: 200 }} />

                </Box>
                <Divider />
            </Box>)
        }
    }
    return (
        <>
            <Dialog
                open={props.open}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
                className={TableStyle.fileTypeModalWrapper}
                fullWidth
            >
                <DialogTitle id="alert-dialog-slide-title">
                    Benefit {currentBenefit?.benefitName}
                </DialogTitle>
                <DialogContent>
                    <Box
                        component="form"
                        sx={{
                            '& .MuiTextField-root': { m: 1, width: '25ch' },
                        }}
                        noValidate
                        autoComplete="off"
                    >
                        <Box className="row">
                            <Box className="col-6">
                                <FormControl sx={{ m: 1, minWidth: 220 }} size="small">
                                    <InputLabel htmlFor="filled-EmployerAmount-percent"
                                        shrink>Benefit Name</InputLabel>
                                    <TextField
                                        style={{ "marginLeft": 0, "marginTop": "16px" }}
                                        {...register('benefitName')}
                                        id="benefitName"
                                        name="benefitName"
                                        value={benefitName}
                                        shrink
                                        variant="standard"
                                        onChange={(e) => {
                                            setBenefitName(e.target.value)
                                            setValue('benefitName', e.target.value, { shouldValidate: true })
                                        }}
                                    />
                                </FormControl>
                            </Box>
                            <Box className="col-6">
                                <FormControl sx={{ m: 1, minWidth: 220 }} >
                                    <InputLabel id="benefitTypeID" shrink>Benefit Type</InputLabel>
                                    <Select
                                        {...register('benefitTypeID')}
                                        id="benefitTypeID"
                                        name="benefitTypeID"
                                        label="Benefit Type"
                                        value={benefitTypeID || ''}
                                        onChange={(e) => {
                                            setBenefitTypeID(e.target.value)
                                            setValue('benefitTypeID', e.target.value, { shouldValidate: true })
                                        }}
                                        required
                                        shrink
                                        variant="standard"
                                        error={errors['benefitTypeID'] ? true : false}
                                        helpertext={errors['benefitTypeID']?.message}
                                    >
                                        {benefitTypeList.map((val, i) => <MenuItem value={val.benefitTypeID} key={i}
                                            size="small">{val.benefitTypeName}</MenuItem>)}
                                    </Select>
                                </FormControl>
                            </Box>
                            <Box className="col-6">
                                <FormControl sx={{ m: 1, minWidth: 220 }} >
                                    <InputLabel id="type-of-hour-select-label">Carrier</InputLabel>
                                    <Select
                                        {...register('carrierID')}
                                        id="carrierID"
                                        name="carrierID"
                                        label="Carrier"
                                        value={carrierID || ''}
                                        onChange={(e) => {
                                            setCarrierID(e.target.value)
                                            setValue('carrierID', e.target.value, { shouldValidate: true })
                                        }}
                                        required
                                        shrink
                                        size="small"
                                        variant="standard"
                                        error={errors['carrierID'] ? true : false}
                                        helpertext={errors['carrierID']?.message}
                                    >
                                        {carrierList.map((val, i) => <MenuItem value={val.carrierID} key={i}>{val.carrierName}</MenuItem>)}
                                    </Select>
                                </FormControl>
                            </Box>
                            <Box className="col-6">
                                <FormControl sx={{ m: 1, minWidth: 220 }}>
                                    <InputLabel id="type-of-hour-select-label">Calculation Type</InputLabel>
                                    <Select
                                        {...register('variableTypeID')}
                                        id="variableTypeID"
                                        name="variableTypeID"
                                        label="Calculation Type"
                                        value={variableTypeID || ''}
                                        onChange={(e) => {
                                            setVariableTypeID(e.target.value)
                                            setValue('variableTypeID', e.target.value, { shouldValidate: true })
                                        }}
                                        required
                                        shrink
                                        size="small"
                                        variant="standard"
                                        error={errors['variableTypeID'] ? true : false}
                                        helpertext={errors['variableTypeID']?.message}
                                    >
                                        {benefitCalcTypes.map((val, i) => <MenuItem value={val.variableTypeID} key={i}>{val.variableTypeName}</MenuItem>)}
                                    </Select>
                                </FormControl>
                            </Box>
                        </Box>
                        <div>
                            {/* <FormControl sx={{ m: 1, minWidth: 200 }}>
                                <FormControlLabel control={<Checkbox checked={isHwContribution} />} label="H&W contribution" />
                            </FormControl> */}
                            <FormControl sx={{ m: 1, minWidth: 200 }}>
                                <FormControlLabel control={<Checkbox
                                    {...register('isFringeCost')}
                                    id="isFringeCost"
                                    checked={isFringeCost}
                                    onChange={(e) => {
                                        setIsFringeCost(e.target.checked)
                                        setValue('isFringeCost', e.target.checked)
                                    }}
                                />} label="Taken against fringe" />
                            </FormControl>
                        </div>
                        <div>
                            <Paper sx={{ p: 2 }}>
                                <FormLabel component="legend">Coverage Levels</FormLabel>
                                <Box >
                                    {
                                        coverageList.map((c, index) =>
                                        (
                                            renderCoverage(c, index)
                                        ))
                                    }

                                </Box>
                            </Paper>
                        </div>
                    </Box>
                </DialogContent>
                <DialogActions className={ButtonStyle.buttonWrapper}>
                    <Button
                        variant="outlined"
                        onClick={handleSubmit(onSubmit)}
                        disabled={savingData}
                    >
                        {(savingData ? "Saving" : "Save")}
                    </Button>
                    <Button variant="outlined" onClick={handleClose}>
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>


            <Dialog
                open={openRates}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleRatesClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
                className={TableStyle.fileTypeModalWrapper}
                fullWidth
            >
                <DialogTitle id="alert-dialog-slide-title">
                {(coverageRates != null && coverageRates.length > 0) ? coverageRates[0].rateVariableTypeName : ""} Rates
                </DialogTitle>
                <DialogContent>
                    <Box
                        component="form"
                        sx={{
                            '& .MuiTextField-root': { m: 1, width: '25ch' },
                        }}
                        noValidate
                        autoComplete="off"
                    >
                        <Box className="row">
                            <Box className="col-12">
                                {
                                    (coverageRates != null && coverageRates.length > 0) ? renderCoverageRate(coverageRates[0].rateVariableTypeCode, coverageRates) : <></>
                                }
                            </Box>
                        </Box>
                    </Box>
                </DialogContent>
                <DialogActions className={ButtonStyle.buttonWrapper}>
                    <Button variant="outlined" onClick={handleRatesClose}>
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>

            <Snackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center'
                }}
                open={openSnack}
                onClose={() => setOpenSnack(false)}
                autoHideDuration={5000}
                message="Benefit setting saved successfully!"
                key="bottom-center-snack"
            >
                <Alert
                    onClose={() => setOpenSnack(false)}
                    severity="success" sx={{ width: '100%' }}>
                    Benefit setting saved successfully!
                </Alert>
            </Snackbar>

        </>
    )
}